import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Modal from '@mui/material/Modal';
import Carousel from 'react-material-ui-carousel'
import ReactGA from 'react-ga';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { cookieKeys } from "../services/Cookies";
import { getRequest } from "../services/ApiServices";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { getCookie } from "../services/Cookies";
import { cookieObj } from "../models/cookieObj";
import ImageGallery from "react-image-gallery";
import MultiMenu from "./Left-nav-multi";
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Collapse from '@material-ui/core/Collapse';
import Blink from 'react-blink-text';
import { getTrendsShip } from "../services/FunctionServices"
import { Menu, MenuItem, Typography } from "@material-ui/core";
import { logUserActivity } from "../services/FunctionServices";
import { toast } from "react-toastify";
import { ToastError, ToastSuccess } from "../services/ToastMsg";
import { Paper } from '@mui/material';
import { useDispatch } from "react-redux";
import { LOADING } from "../action";
//icons
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import JsFileDownloader from 'js-file-downloader';
import axios from "axios";



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "70%",
  height: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const leftSideMenuDetails = require("../../data/leftSideMenu.json");
const useStyles = makeStyles((theme) => ({
  menuBox: {
    color: "#fff",
    fontFamily: "Bai Jamjuree, sans-serif !important",
  },
  navListItem: {
    "& .mactive": {
      backgroundColor: "#ff4717",
    },
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginLeft: "500px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  btnStyle3: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "8px 300px",
    position: "absolute",
    marginLeft: "210px",
  },
  blinktext: {
    animation: "blinker 1s step-start infinite",
    color: "#FF4717"

  },
  link: {
    textTransform: "capitalize",
    color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
    }

  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  heading: {
    textAlign: "center",
    fontSize: "30px",
    fontWeight: "bold"
  },
  heading1: {
    padding: "1px",
    textAlign: "center",
    fontWeight: "bold"
  },
  heading2: {
    padding: "3px",
    textAlign: "center",
    fontWeight: "bold",
    color: "#ff4717 ",
  }, gallerySlider: {
    "& .image-gallery .image-gallery-icon:hover svg": {
      color: "#1a1a31",
    },
    "& .image-gallery .image-gallery-left-nav ": {
      left: "-50px",
    },
    "& .image-gallery .image-gallery-right-nav ": {
      right: "-50px",
    },
    "& .image-gallery .image-gallery-bullets ": {
      bottom: "-40px",
    },
    "& .image-gallery .image-gallery-bullets .image-gallery-bullet": {
      boxShadow: "0 0 0 #1a1a31",
      padding: "6px",
      margin: "0 10px",
      border: "1px solid #1a1a31",
    },
    "& .image-gallery .image-gallery-bullets .image-gallery-bullet.active": {
      background: "#1a1a31",
    },
  },

}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function LeftSideMenu(props) {

  //console.log(props);
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState("home");
  const [leftSideMenu, setLeftSideMenu] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openTrends, setOpenTrends] = React.useState(false);
  const [OpenScheduler, setOpenScheduler] = React.useState(false);
  const [assetValueSchedular, setAssetValueSchedular] = React.useState('');
  const [assetValue, setAssetValue] = React.useState('');
  const [trendValue, settrendValue] = React.useState('');
  const [menuPosition, setMenuPosition] = React.useState('');
  const [menuPosition1, setMenuPosition1] = React.useState('');
  const [open1, setOpen1] = React.useState(false);
  const [BunkerMaster, setBunkerMaster] = React.useState("")

  const handleRightClick = (event) => {
    //
    if (getCookie('bM_ACCESS_STATUS') == "" || getCookie('bM_ACCESS_STATUS') == "Denied" || getCookie('bM_ACCESS_STATUS') == 'null') {
      if(getCookie('type') !== "Bunker Master Only"){
      setOpen1(true);
      }
      //   const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      //   `User/RequestBMAccess`;
      // getRequest(url)
      // ToastError("Bunker master access requested");
      // history.push("/dashboard");
    } else if (getCookie('bM_ACCESS_STATUS') == "Requested" && getCookie('type') !== "Bunker Master Only") {
      ToastError("Your request Approval is awaiting ");
      history.push("/dashboard");
    } else if (getCookie('bM_ACCESS_STATUS') == "Approved") {
      if (menuPosition) {
        return;
      }
      event.preventDefault();
      setMenuPosition({
        top: event.pageY,
        left: event.pageX
      });
    }

    //setActiveKey("bunker_master");
  };
  const handleRightClick1 = (event) => {
    //
    if (menuPosition1) {
      return;
    }
    event.preventDefault();
    setMenuPosition1({
      top: event.pageY,
      left: event.pageX
    });
  }
  useEffect(() => {
    //
    /* handleClickOpen(); */
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + "Navigation";
    getRequest(url).then((res) => {
      const assetTypes = getCookie("assetTypes").split(',');
      var hasVessel = assetTypes.indexOf('Vessels') > -1 ? true : false;
      var data = [];
      //console.log(res);

      res.data.forEach(element => {
        if (!(!hasVessel && element.screenname == "Alerts")) {
          data.push(element);
        }
      });

      setLeftSideMenu(data);
    });
    // const cookieKey = document.cookie;
    // if (cookieKey.indexOf("sampler") > -1) {
    //   setLeftSideMenu(leftSideMenuDetails.sampler);
    // } else if (cookieKey.indexOf("fleetManager") > -1) {
    //   setLeftSideMenu(leftSideMenuDetails.fleetManager);
    // } else if (cookieKey.indexOf("transformer") > -1) {
    //   setLeftSideMenu(leftSideMenuDetails.fleetManager);
    // } else if (cookieKey.indexOf("ccReports") > -1) {
    //   setLeftSideMenu(leftSideMenuDetails.ccReports);
    // }
  }, []);


  let options = [
    {
      title: "Education",
      titleIcon: <i className="fa fa-graduation-cap"></i>,
      content: [{ id: 1, name: "My courses", to: "/my-courses" }]
    },
    {
      title: "Most popular",
      titleIcon: <i className="fa fa-paragraph"></i>,
      hideBorder: true,
      content: [
        {
          id: 2,
          name: "Web Development",
          icon: <i className="fa fa-chrome"></i>,
          children: [
            {
              title: "JavaScript",
              titleIcon: <i className="fa fa-opera"></i>,
              content: [
                {
                  id: 3,
                  name: "functions",
                  ["Some property i need on clicking this"]: "value"
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  const handleClickOpen = (type) => {
    //
    //console.log(type,"type");
    const assetTypes = getCookie("assetTypes").split(',');
    const serviceTypes = getCookie("serviceTypes");
    if (type == "assets") {
      if (assetTypes.length > 1) {
        setOpen(true);
      } else {
        if (assetTypes[0] == "Vessels") {
          history.push("/dashboard/assets");
        } else {
          history.push("/dashboard/assets-transformers");
        }
      }
    } else if (type == "Scheduler") {
      debugger;
      if (assetTypes.length > 1) {
        setOpenScheduler(true);
      } else if (assetTypes[0] == "Vessels") {
        history.push("/dashboard/scheduler");
      } else if (assetTypes[0] == "Transformer") {
        history.push("/dashboard/scheduler-transformer");
      }
    } else if (type == "trends") {
      if (assetTypes.length > 1) {
        setOpenTrends(true);
      } else {
        if (assetTypes[0] == "Vessels") {
          if (getTrendsShip().length > 1) {
            setOpenTrends(true);
          } else if (getTrendsShip().length == 1) {
            if (getTrendsShip()[0] == "Fuel") {
              history.push("/dashboard/trendsships");
            } else if (getTrendsShip()[0] == "Lube") {
              history.push("/dashboard/trends-ships-ocm");
            }
          }
        } else {
          history.push("/dashboard/trends");
        }
      }
    }



  };
  const handleSidebarToggle = isOpen => {
    this.setState({ isOpen });
  };
  const handleAssetsClose = () => {

    setOpen(false);
  };
  const handleAssetsCloseSchedular = () => {
    setOpenScheduler(false);
  }
  const handleTrendsClose = () => {

    setOpenTrends(false);
  };
  const navigationToPageAssets = (page) => {
    //
    if (page == "Ship_Page") {
      history.push("/dashboard/assets");
      handleAssetsClose()
    } else {
      history.push("/dashboard/assets-transformers");
      handleAssetsClose()
    }
  }
  const navigationToPageAssetsSchedular = (page) => {
    //
    if (page == "Ship_Page") {
      history.push("/dashboard/scheduler");
      handleAssetsCloseSchedular();
    } else {
      history.push("/dashboard/scheduler-transformer");
      handleAssetsCloseSchedular();
    }
  }
  const navigationToPageTrends = (page) => {
//
    if (page == "Fuel") {
      history.push("/dashboard/trendsships");
      handleTrendsClose()
    } else if (page == "Lube") {
      history.push("/dashboard/trends-ships-ocm");
      handleTrendsClose()
    } else {
      history.push("/dashboard/trends");
      handleTrendsClose()
    }
  }
  const handleAssetRadioChange = (event) => {

    setAssetValue(event.target.value);
  }
  const handleAssetRadioChangeSchedular = (event) => {

    setAssetValueSchedular(event.target.value);
  }
  const handleTrendRadioChange = (event) => {

    settrendValue(event.target.value);
  }

  var items = [
    {
      name: <img src="/assets/images/BM-Request-bg.jpg"></img>,

    },
    {
      name: <img src="/assets/images/BM-request-bg-1.jpg"></img>,

    },
    {
      name: <img src="/assets/images/BM-request-bg-2.jpg"></img>,
    },
    {
      name: <img src="/assets/images/BM-request-bg-3.jpg"></img>,
    }
  ]



  const handleClose1 = () => {
    ////
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `User/RequestBMAccess`;
    getRequest(url)
    ToastError("Bunker master access requested");
    history.push("/dashboard");
    setOpen1(false);
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const getBunkerMaster = () => {
    //
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerMaster`;
    getRequest(url)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setBunkerMaster(res.data[0]);
          loadExcelFile(res.data[0]);
          //loadPdfFile(res.data[0]);
          //setBunkerAlertsActive(res.data[0])
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  const loadExcelFile = (data) => {
    //
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerMaster/file`;
    let filedata = JSON.stringify({ fileName: data });
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/vnd.ms-excel"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        if (response.status == 200) {
          //
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "application/vnd.ms-excel" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          var link = document.createElement('a');
          link.href = fileURL;
          //document.body.appendChild(link);
          link.click();
          //window.open(fileURL,'_blank');
          //setOpenBunkerAlerts(fileURL);
        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };
  const fileUrl = '@public/assets/ExcelSheet/FuelChangeoverTemplate.xlsx';

  const ExcelDownloader = () => {
    //
    new JsFileDownloader({
      url: fileUrl
    })
      .then(function () {
        ToastSuccess("Excel File is Downloaded")
      })
      .catch(function (error) {
        ToastError("Excel File is Not Downloaded")
      });
  }
  function Item(props) {
    return (
      <Paper >
        <div className="minheight600">{props.item.name}</div>
      </Paper>
    )
  }



  return (
    <div className="left-navd">
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpen1}>
          Open alert dialog
        </Button> */}
        {/* <Dialog
          open={open1}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
        >
          <DialogTitle id="alert-dialog-title">
            {"Access to the Bunker master"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You need to request access to the Bunker Master Application?

              <br></br>
              Do you want to raise a request  for Access?


            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose1}>Cancel</Button>
            <Button onClick={handleClose} autoFocus>
              Raise Request
            </Button>
          </DialogActions>
        </Dialog> */}

        <Modal
          open={open1}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          disableEscapeKeyDown
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" className={classes.heading}>
              Welcome to Bunker Master
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
              To request a Bunker Master Access  <Button className={classes.link} onClick={handleClose1}>Click here</Button>
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
              or know more about Bunker Master Access latest features
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading2}>
              C0<sub>2</sub> Calculations
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
              This Module performs Co<sub>2</sub> related Calculations
            </Typography>

            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
              {/* <img className="maxwidth50" src="/assets/images/VLSFO-1.jpg"></img> */}
              {/* <Carousel
                NavButton={({ onClick, className, style, next, prev }) => {
                  // Other logic

                  return (
                    <Button onClick={onClick} className={className} style={style}>
                      {next && "Next"}
                      {prev && "Previous"}
                    </Button>
                  )
                }}
              >
                
              </Carousel> */}
              {/* <Carousel
                 fullHeightHover={false}     // We want the nav buttons wrapper to only be as big as the button element is
                 navButtonsProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                     style: {
                         backgroundColor: '#e53c1f',
                         borderRadius: 0
                     }
                 }} 
                 navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
                     style: {
                         bottom: '0',
                         top: 'unset'
                     }
                 }} 
                 NextIcon='>'             // Change the "inside" of the next button to "next"
                 PrevIcon='<'
                 className="bunkerCarousel"
              > */}
              <div className={classes.paper + " scrollBar"} style={{ height: "550px", overflow: "auto" }}>
                {
                  items.map((item, i) => <Item key={i} item={item} />)
                }
              </div>
              {/* </Carousel> */}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
              To request a Bunker Master Access
            </Typography>
            {/* <Button className={classes.btnStyle1}onClick={handleClose}>Cancel</Button> */}
            <Button className={classes.btnStyle3} onClick={handleClose1} autoFocus>
              Request For Bunker Master Access
            </Button>
          </Box>
        </Modal>
      </div>
      <Menu className="left-send-nav"
        open={!!menuPosition}
        onClose={() => { ; setMenuPosition(null); setActiveKey("bunker_master"); }}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
      >
        <span className="cal-head">Calculations</span>
        <MenuItem onClick={() => { ; setMenuPosition(null); history.push("/dashboard/bunker-master"); }}>Energy Calculation</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/IgnitionQuality"); }}>Ignition Quality Calculation</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/GravityConversation"); }}>Gravity Calculation  </MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/QuantityConversation"); }}>Quantity Conversion</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/QuantityDetermination"); }}>Quantity Determination</MenuItem>

        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/ViscocityCalculation"); }}>Viscosity Calculation</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/BlendCalculation"); }}>Blend Calculation</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/TemperatureConversion"); }}>Temperature Conversion</MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); getBunkerMaster() }}>Fuel Change-Over</MenuItem>

        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/Co2Calculator"); }}>CO<sub>2</sub>   </MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/SoxCalculator"); }}>SOx  </MenuItem>
        <MenuItem onClick={() => { setMenuPosition(null); history.push("/dashboard/NoxCalculator"); }}>NOx  </MenuItem>
      </Menu>

      <Menu className="left-send-nav reports-left-nav"
        open={!!menuPosition1}
        onClose={() => { setMenuPosition1(null); setActiveKey("reports"); }}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition1}
      >
        {/* <span className="cal-head">Reports</span> */}
        <MenuItem onClick={() => { setMenuPosition1(null); history.push("/dashboard/reports"); }}>Reports </MenuItem>
        <MenuItem onClick={() => { setMenuPosition1(null); history.push("/dashboard/dataaccess"); }}>Downloads</MenuItem>
      </Menu>
      <List className={clsx(classes.navListItem, "navListItem", "leftsidenav")}>

        {leftSideMenu.length
          ? leftSideMenu.map((item) =>
            item.screenname.toLowerCase() == "bunker master" ? (
              <ListItem style={{ display: 'flex' }}
                button
                key={item.screenname}
                className={clsx(
                  props.location.pathname == '/dashboard/bunkerMaster' ? "mactive" : "Inmactive",
                  props.location.pathname.indexOf("/dashboard/") > -1
                    ? props.location.pathname.indexOf(
                      "/dashboard/bunker-master"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/IgnitionQuality"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/GravityConversation"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/QuantityConversation"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/QuantityDetermination"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/ViscocityCalculation"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/BlendCalculation"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/TemperatureConversion"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/Co2Calculator"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/SoxCalculator"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/NoxCalculator"
                    ) > -1 &&
                      item.screenname.toLowerCase().split(" ").join("_") != ""
                      ? "mactive"
                      : ""
                    : props.location.pathname.indexOf(
                      item.screenname.toLowerCase().split(" ").join("_")
                    ) > -1 &&
                      item.screenname.toLowerCase().split(" ").join("_") == ""
                      ? "mactive"
                      : "",
                  // props.location.pathname == '/dashboard/sample-status'? "mactive": "Inmactive",
                  // props.location.pathname == '/dashboard'? "mactive": "Inmactive", 
                  classes.menuBox
                )}
                onClick={handleRightClick}
              >
                {/* <ListItemIcon>{item.icon}</ListItemIcon> */}

                <Box
                  component="img"
                  src={
                    "/assets/svg/" +
                    (item.screenname == "Decarbonisation" ? item.screenname : item.screenname == "Analytics" ? "analytics_db" : item.screenname.toLowerCase().split(" ").join("_")) +
                    ".svg"
                  }
                  width="0.15"
                  mr={1}
                  color="#fff"
                />
                <ListItemText primary={item.screenname} />
                {/* {(item.screenname == "Bunker Master" ? getCookie('bm_ACCESS_STATUS') == "Requested" ? <span style={{ color: "#FF4717", animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>Pending</sup></span> : <span style={{ color:"#FFFFFF" , animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>Pending</sup></span>:"")} */}
              </ListItem>
            )
              : item.screenname.toLowerCase() != "logout" &&
                item.screenname.toLowerCase() != "dashboard" &&
                item.screenname.toLowerCase() != "bunker master"
                ? (
                  <ListItem style={{ display: (item.screenname.toLowerCase() == 'trends' || item.screenname.toLowerCase() == 'contracts' || item.screenname.toLowerCase() == 'assets') && getCookie('serviceTypes') == 'BQS' ? 'none' : 'flex' }}
                    button
                    key={item.screenname}
                    className={clsx(
                      props.location.pathname.indexOf("/dashboard/") > -1
                        ? props.location.pathname.indexOf(
                          item.screenname.toLowerCase().split(" ").join("_")
                        ) > -1 || props.location.pathname.indexOf(
                          item.screenname.toLowerCase().split(" ").join("-")
                        ) > -1 &&
                          item.screenname.toLowerCase().split(" ").join("_") != ""
                          ? "mactive"
                          : ""
                        : props.location.pathname.indexOf(
                          item.screenname.toLowerCase().split(" ").join("_")
                        ) > -1 &&
                          item.screenname.toLowerCase().split(" ").join("_") == ""
                          ? "mactive"
                          : "",
                      classes.menuBox
                    )}

                    onClick={(e) => {
                      //
                      if (item.screenname.toLowerCase().split(" ").join("_") == "assets") {
                        handleClickOpen('assets');
                      } else if (item.screenname.toLowerCase().split(" ").join("_") == "trends") {
                        handleClickOpen('trends');
                      } else if (item.screenname.toLowerCase().split(" ").join("_") == "reports") {
                        handleRightClick1(e);
                      } else if (item.screenname.toLowerCase().split(" ").join("_") == "scheduler") {
                        handleClickOpen('Scheduler');
                      } else {

                        setActiveKey(
                          item.screenname.toLowerCase().split(" ").join("_")
                        );

                        // if (item.screenname.toLowerCase().split(" ").join("_") == "request_for_bunker_master_access") {
                        //   const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
                        //     `User/RequestBMAccess`;
                        //   getRequest(url)
                        //   ToastError("Bunker master access requested");
                        //   history.push("/dashboard");
                        // } else if (item.screenname.toLowerCase().split(" ").join("_") == "bunker_master_access_awaiting_approval") {
                        //   ToastError("Your request Approval is awaiting ");
                        //   history.push("/dashboard");
                        // }
                        // else {
                        history.push(
                          "/dashboard" +
                          (item.screenname
                            ? "/" +
                            item.screenname.toLowerCase().split(" ").join("-")
                            : "")
                        );
                        // }
                      }


                    }}
                  >
                    {/* <ListItemIcon>{item.icon}</ListItemIcon> */}

                    <Box
                      component="img"
                      src={
                        "/assets/svg/" +
                        (item.screenname == "Decarbonisation" ? item.screenname : item.screenname == "Analytics" ? "analytics_db" : item.screenname.toLowerCase().split(" ").join("_")) +
                        ".svg"
                      }
                      width="0.15"
                      mr={1}
                      color="#fff"
                    />

                    <ListItemText primary={item.screenname} />
                    {(item.screenname == "Customer Support" ? props.location.pathname.indexOf("customer-support") > -1 ? <span style={{ color: "#FFFFFF", animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>New</sup></span> : <span style={{ color: "#FF4717", animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>New</sup></span> : "")}
                    {(item.screenname == "Bunker Master" ? <span></span> : "")}
                    {(item.screenname == "DataAccess" ? <span></span> : "")}
                    {(item.screenname == "UserAnalytics" ? <span></span> : "")}
                    {(item.screenname == "Decarbonisation" ? <span></span> : "")}
                    {(item.screenname == "Analytics" ? <span></span> : "")}
                    {(item.screenname == "CII Dashboard" ? <span></span> : "")}
                    {(item.screenname == "Global Filter" ? <span></span> : "")}
                   

                  </ListItem>
                ) : item.screenname.toLowerCase() == "dashboard" ? (
                  <ListItem style={{ display: item.screenname.toLowerCase() == 'dashboard' && getCookie('serviceTypes') == 'BQS' ? 'none' : 'flex' }}
                    button
                    key={item.screenname}
                    className={clsx(
                      props.location.pathname == '/dashboard/sample-status' ? "mactive" : "Inmactive",
                      props.location.pathname == '/dashboard' ? "mactive" : "Inmactive",
                      classes.menuBox
                    )}
                    onClick={() => {
                      //
                      setActiveKey(
                        item.screenname.toLowerCase().split(" ").join("_")
                      );
                      history.push("/dashboard");
                    }}
                  >
                    {/* <ListItemIcon>{item.icon}</ListItemIcon> */}

                    <Box
                      component="img"
                      src={
                        "/assets/svg/" +
                        (item.screenname == "Decarbonisation" ? item.screenname : item.screenname == "Analytics" ? "analytics_db" : item.screenname.toLowerCase().split(" ").join("_")) +
                        ".svg"
                      }
                      width="0.15"
                      mr={1}
                      color="#fff"
                    />
                    <ListItemText primary={item.screenname} />

                  </ListItem>
                ) : (

                  <ListItem
                    button
                    key={item.screenname}
                    className={clsx(
                      props.location.pathname.indexOf("/dashboard/") > -1
                        ? props.location.pathname.indexOf(
                          item.screenname.toLowerCase().split(" ").join("_")
                        ) > -1 &&
                          item.screenname.toLowerCase().split(" ").join("_") != ""
                          ? "mactive"
                          : ""
                        : props.location.pathname.indexOf(
                          item.screenname.toLowerCase().split(" ").join("_")
                        ) > -1 && item.screenname == ""
                          ? "mactive"
                          : "",
                      classes.menuBox
                    )}
                    onClick={() => {
                      //
                      // let data = {
                      //   name: "",
                      //   username: "",
                      //   type: "",
                      //   profileImg: "",
                      //   token: "",
                      //   assetTypes: ""
                      // };
                      // ;
                      // cookieKeys(data, 0);


                      cookieKeys(cookieObj, 0);
                      localStorage.clear();
                      setActiveKey(
                        item.screenname.toLowerCase().split(" ").join("_")
                      );
                      // history.push("/sign-in");
                      setTimeout(function () {
                        history.push("/sign-in");
                      }, 100);
                    }}
                  >

                    {/* <ListItemIcon>{item.icon}</ListItemIcon> */}

                    <Box
                      component="img"
                      src={
                        "/assets/svg/" +
                        (item.screenname == "Decarbonisation" ? item.screenname : item.screenname == "Analytics" ? "analytics_db" : item.screenname.toLowerCase().split(" ").join("_")) +
                        ".svg"
                      }
                      width="0.15"
                      mr={1}
                      color="#fff"
                    />

                    <ListItemText primary={item.screenname} />
                  </ListItem>
                )
          )
          : ""}


      </List>
      {/* <List className={clsx(classes.navListItem, "navListItem", "leftsidenav")}>

        {leftSideMenu.length
          ? leftSideMenu.map((item) =>
            item.screenname.toLowerCase() == "reports" ? (
              <ListItem style={{ display: 'flex' }}
                button
                key={item.screenname}
                className={clsx(
                  props.location.pathname.indexOf("/dashboard/") > -1
                    ? props.location.pathname.indexOf(
                      "/dashboard/reports"
                    ) > -1 || props.location.pathname.indexOf(
                      "/dashboard/dataaccess"
                    ) > -1 &&
                      item.screenname.toLowerCase().split(" ").join("_") != ""
                      ? "mactive"
                      : ""
                    : props.location.pathname.indexOf(
                      item.screenname.toLowerCase().split(" ").join("_")
                    ) > -1 &&
                      item.screenname.toLowerCase().split(" ").join("_") == ""
                      ? "mactive"
                      : "",

                  classes.menuBox
                )}

              >


                <Box
                  component="img"
                  src={
                    "/assets/svg/" +
                    item.screenname.toLowerCase().split(" ").join("_") +
                    ".svg"
                  }
                  width="0.15"
                  mr={1}
                  color="#fff"
                />
                <ListItemText primary={item.screenname} /> */}
      {/* {(item.screenname == "Bunker Master" ? getCookie('bm_ACCESS_STATUS') == "Requested" ? <span style={{ color: "#FF4717", animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>Pending</sup></span> : <span style={{ color:"#FFFFFF" , animation: "blinker 1s step-start infinite", fontSize: 50 }}><sup>Pending</sup></span>:"")} */}
      {/* </ListItem>
            )
              : ""
          )
          : ""}


      </List> */}
      <Box display="flex" justifyContent="flex-end" className={classes.footerBox + " footertext"} component="a" href="http://www.natobotics.com" target="blank">
        <Box component="span" marginRight="15px" marginTop="15px" fontSize="10px" color="white">
          <div>Powered By  Natobotics</div>

        </Box>


        <Box
          component="img"
          display="block"
          height="50%"

          src={
            process.env.REACT_APP_CUSTOMER_PORTAL_URL +
            "assets/images/natobotics-logo.png"
          }
        />
      </Box>

      <Dialog
        open={OpenScheduler}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAssetsCloseSchedular}
      >
        <DialogActions>
          <FormControl >
            <RadioGroup aria-label="aseets" name="aseets" value={assetValueSchedular} onChange={handleAssetRadioChangeSchedular} >
              <FormControlLabel
                // onChange={()=>{navigationToPage("Ship_Page")}}
                value="Ship_Page" control={<Radio />} color="secondary" label="Ships" />
              <FormControlLabel
                // onChange={()=>{navigationToPage("Tran_Page")}}
                value="Transformers" control={<Radio />} color="secondary" label="Transformers" />
              <Button className={classes.btnStyle2} onClick={() => { navigationToPageAssetsSchedular(assetValueSchedular); }}>Ok</Button>
            </RadioGroup>
          </FormControl>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAssetsClose}
      >
        <DialogActions>
          <FormControl >
            <RadioGroup aria-label="aseets" name="aseets" value={assetValue} onChange={handleAssetRadioChange} >
              <FormControlLabel
                // onChange={()=>{navigationToPage("Ship_Page")}}
                value="Ship_Page" control={<Radio />} color="secondary" label="Ships" />
              <FormControlLabel
                // onChange={()=>{navigationToPage("Tran_Page")}}
                value="Transformers" control={<Radio />} color="secondary" label="Transformers" />
              <Button className={classes.btnStyle2} onClick={() => { navigationToPageAssets(assetValue); }}>Ok</Button>
            </RadioGroup>
          </FormControl>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openTrends}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleTrendsClose}
      >
        <DialogActions >
          <FormControl >
            <RadioGroup aria-label="trends" name="trends" value={trendValue} onChange={handleTrendRadioChange} >
              {
                getCookie("serviceTypes") ? (
                  <React.Fragment>
                    <FormControlLabel
                      // onChange={()=>{navigationToPageTrends("Fuel")}} 
                      value="Fuel" control={<Radio />} color="secondary" label="Fuel Analysis" />
                    <FormControlLabel
                      // onChange={()=>{navigationToPageTrends("Lube")}} 
                      value="Lube" control={<Radio />} color="secondary" label="Lube Analysis " />
                  </React.Fragment>
                ) : ""
              }

              {
                getCookie("assetTypes").split(',').length > 1 ? (<FormControlLabel
                  // onChange={()=>{navigationToPageTrends("Tran_Page")}} 
                  value="Tran_Page" control={<Radio />} color="secondary" label="Transformers" />) : ""
              }
              <Button className={classes.btnStyle2} onClick={() => { navigationToPageTrends(trendValue); }}>Ok</Button>


            </RadioGroup>
          </FormControl>
        </DialogActions>
      </Dialog>

    </div>
  );
}
